<template>

    <v-container>


        <!--DELETE - Dialog-->
        <v-dialog
                persistent
                v-model="deleteDialog" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">Delete Supplier Order</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" v-model="deleteFormValidation" lazy-validation>
                        <v-checkbox
                                :rules="[v => !!v || 'You have to check this to continue!']"
                                required
                                v-model="deleteChecked" color="primary"
                                label="Do you really want to delete this supplier order?"></v-checkbox>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="cancelDeleteDialog()">CANCEL</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="deleteOrder()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-layout row wrap>

            <v-flex xs12 sm12 mb-2>

                <v-btn v-if="procurementId === null" class="secondary white--text" @click.stop="openDialog(null)">
                    New Supplier Order
                    <v-icon class="white--text" right>add</v-icon>
                </v-btn>

            </v-flex>

        </v-layout>

        <v-layout row wrap>

            <v-flex xs12 sm12>
                <v-layout row>
                    <v-flex xs12>
                        <v-card>
                            <v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12 md8>
                                        <v-card-title class="headline">
                                            Supplier Orders
                                        </v-card-title>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="search"
                                                append-icon="search"
                                                label="Search"
                                                single-line
                                                hide-details
                                                clearable
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>

                            <!--                            Status Or Filter Header-->
                            <!--                            <v-layout row wrap>
                                                            <v-flex xs12 md2 pl-4 pr-2>
                                                                <v-autocomplete
                                                                        clearable
                                                                        :items="getAllSuppliers"
                                                                        label="Supplier"
                                                                        v-model="selectedSupplierID"
                                                                        item-value="id"
                                                                        item-text="name"
                                                                        :loading="loading"
                                                                ></v-autocomplete>
                                                            </v-flex>

                                                        </v-layout>-->

                            <v-data-table
                                    :headers="headers"
                                    :items="getItems"
                                    :pagination.sync="pagination"
                                    :total-items=total
                                    class="elevation-0"
                                    :loading="loading"
                                    :rows-per-page-items="rowsPageItems"
                            >

                                <template slot="headerCell" slot-scope="props">
                                    <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                        <span>
                                          {{ props.header.text }}
                                        </span>
                                    </v-tooltip>
                                </template>
                                <template slot="items" slot-scope="props">
                                    <v-touch tag="tr"
                                             @doubletap="openDialog(props.item.id)"
                                             @dblclick="openDialog(props.item.id)">
                                        <td>{{ props.item.id }}</td>
                                        <td class="text-xs-left">{{
                                            props.item.procurement.purchase_order.purchase_orders_number }}
                                        </td>
                                        <td class="text-xs-left">{{ props.item.purchase_orders_number }}</td>
                                        <td class="text-xs-left">{{ props.item.supplier.name }}</td>
                                        <td class="text-xs-left">{{
                                            props.item.procurement.purchase_order.account.firstname }} {{
                                            props.item.procurement.purchase_order.account.lastname}}
                                        </td>
                                        <td class="text-xs-center">
                                            <v-progress-linear
                                                    slot="progress"
                                                    :value="calculateProgress(props.item.id)"
                                                    :color="color(props.item.id)"
                                                    height="7"
                                            ></v-progress-linear>
                                        </td>

                                        <td class="text-xs-center">
                                            {{ getPositionCount(props.item.suppliers_orders_positions) }} / {{
                                            props.item.suppliers_orders_positions.length }}
                                        </td>
                                        <td class="text-xs-left">{{ props.item.suppliers_orders_status.name }}</td>
                                        <td class="text-xs-left"> {{ props.item.created_at | toDateTimeLocalTime }}</td>

                                        <td v-if="procurementId !== null" class="text-xs-right">
                                            <v-icon color="red"
                                                    class="ma-1"
                                                    @click="deletePositionDialog(props.item)"
                                            >
                                                delete
                                            </v-icon>
                                        </td>

                                    </v-touch>

                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>

                </v-layout>

                <addSupplierOrderDialog :procurementId="procurementId"></addSupplierOrderDialog>

            </v-flex>
        </v-layout>

    </v-container>

</template>

<script>
    import {
        Settings,
        SupplierOrder
    } from '../../store/namespace-helper'
    import addSupplierOrderDialog from '../SupplierOrders/AddSupplierOrderDialog.vue'
    import _ from 'lodash'

    import {dateFunctionFilters} from '../../mixins/dateFunctionFilters'
    import {stateHelperMixin} from '../../mixins/stateHelperMixin'

    export default {
      name: 'SupplierOrders',
      components: {
        addSupplierOrderDialog
      },
      mixins: [dateFunctionFilters, stateHelperMixin],
      props: {
        procurementId: {
          type: Number,
          default: null
        }
      },
      data () {
        return {
          isVisible: false,
          pagination: {'sortBy': 'id', 'descending': true},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [25, 10, 50, 100, 250],
          deleteDialog: false,
          deleteChecked: false,
          deleteFormValidation: false,
          supplierOrderToDelete: null,
          selectedSupplierID: null
        }
      },
      methods: {
        beforeDestroy () {
          this.resetStateBeforeLeaveRoute()
        },
        mounted () {
          this.loadItems()
          this.loadAllSuppliers()
        },
        openDialog (val) {
          if (val !== null) {
            let item = this.getItems.find(x => x.id === val)
            this.$store.dispatch(SupplierOrder.actions.setSelectedSupplierOrder, item)
            this.$echo.private('messages-chan.' + val).listen('MessageSent', (payload) => {
              console.log('message sent event: ' + JSON.stringify(payload))
              this.$echo.leave('messages-chan.' + val)
              this.loadItems()
            })
          }
          this.$store.dispatch(SupplierOrder.actions.openCloseDialog)
        },
        loadItems () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          if (this.procurementId === null) {
            const query = {
              sortBy: sortBy || 'id',
              descending: descending ? 'desc' : 'asc',
              page: page || 1,
              limit: rowsPerPage !== -1 ? rowsPerPage : 0,
              search: this.search ? this.search : ''
            }
            this.$store.dispatch(SupplierOrder.actions.loadSupplierOrders, query)
          } else {
            const query = {
              id: this.procurementId,
              sortBy: sortBy || 'id',
              descending: descending ? 'desc' : 'asc',
              page: page || 1,
              limit: rowsPerPage !== -1 ? rowsPerPage : 0,
              search: this.search ? this.search : ''
            }
            this.$store.dispatch(SupplierOrder.actions.loadSupplierOrdersForProcurement, query)
          }
        },
        throttledLoadItems: _.debounce(function () {
          this.loadItems()
        }, 450),
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
          setTimeout(function () {
            location.reload()
          }, 850)
        },
        color (val) {
          let item = this.getItems.find(x => x.id === val)
          if (this.getPositionCount(item.suppliers_orders_positions) === item.suppliers_orders_positions.length && item.suppliers_orders_positions.length !== 0) {
            return 'success'
          } else if (this.getPositionCount(item.suppliers_orders_positions) === 0) {
            return 'error'
          } else {
            return 'warning'
          }
        },
        calculateProgress (val) {
          if (val !== null) {
            let item = this.getItems.find(x => x.id === val)
            return (100 / item.suppliers_orders_positions.length) * this.getPositionCount(item.suppliers_orders_positions)
          } else {
            return 0
          }
        },
        getPositionCount (val) {
          let count = 0
          val.forEach(function (item) {
            if (item.suppliers_orders_positions_status_id >= 6) {
              count += 1
            }
          })
          return count
        },
        deletePositionDialog (item) {
          this.supplierOrderToDelete = _.cloneDeep(item)
          this.deleteDialog = true
        },
        deleteOrder () {
          if (!this.$refs.form.validate()) {
            return
          }
          this.deleteDialog = false
          this.deleteChecked = false
          this.$store.dispatch(SupplierOrder.actions.deleteSupplierOrder, this.supplierOrderToDelete).then(response => {
            if (response !== null) {
              this.loadItems()
            }
          })
        },
        cancelDeleteDialog () {
          this.deleteDialog = false
          this.$refs.form.reset()
        },
        loadAllSuppliers: function () {
          this.$store.dispatch(Settings.actions.loadAllSuppliers)
        }
      },
      computed: {
        getItems () {
          this.total = this.$store.getters[SupplierOrder.getters.supplierOrders].total
          return this.$store.getters[SupplierOrder.getters.supplierOrders].data
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        getActiveTab () {
          if (this.procurementId === null) {
            return 0
          } else {
            return 0
          }
        },
        dialogState () {
          return this.$store.getters[SupplierOrder.getters.getOpenDialogState]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        getAllSuppliers () {
          return this.$store.getters[Settings.getters.getAllSuppliers]
        },
        headers () {
          if (this.procurementId !== null) {
            return [
                        {text: 'SupplierOrder-ID', value: 'id'},
              {
                text: 'Customer Order',
                value: 'procurements.purchase_orders.purchase_orders_number',
                sortable: false
              },
                        {text: 'Supplier Purchase Order Number', value: 'purchase_orders_number'},
                        {text: 'Supplier', value: 'suppliers:suppliers_id|suppliers.name'},
                        {text: 'Account', value: 'accounts_id', sortable: false},
                        {text: 'Progress', value: 'progress', sortable: false, align: 'left'},
                        {text: 'Received Positions', value: 'calc_position', sortable: false, align: 'center'},
                        {text: 'Status', value: 'suppliers_orders_status_id', sortable: false},
                        {text: 'Created', value: 'created_at'},
                        {text: 'Action', value: 'actions', sortable: false}
            ]
          } else {
            return [
                        {text: 'SupplierOrder-ID', value: 'id'},
              {
                text: 'Customer Order',
                value: 'procurements.purchase_orders.purchase_orders_number',
                sortable: false
              },
                        {text: 'Supplier Purchase Order Number', value: 'purchase_orders_number'},
                        {text: 'Supplier', value: 'suppliers:suppliers_id|suppliers.name'},
                        {text: 'Account', value: 'accounts_id', sortable: false},
                        {text: 'Progress', value: 'progress', sortable: false, align: 'left'},
                        {text: 'Received Positions', value: 'calc_position', sortable: false, align: 'center'},
                        {text: 'Status', value: 'suppliers_orders_status_id', sortable: false},
                        {text: 'Created', value: 'created_at'}
            ]
          }
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadItems()
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        dialogState: {
          handler (val) {
            if (!val) {
                        // cleanup states
                        // reload supplier list
              this.throttledLoadItems()
            }
          },
          deep: true
        }
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

</style>


// WEBPACK FOOTER //
// src/components/SupplierOrders/SupplierOrders.vue